import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DryMappingRequest as SchemaDryMappingRequest } from '../schemas/DryMappingRequest';
import { type IntegrationType as SchemaIntegrationType } from '../schemas/IntegrationType';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const StartDryMappingIntegrationContentType = 'application/json' as const;
export type StartDryMappingIntegrationRequest = SchemaDryMappingRequest;
export type StartDryMappingIntegrationResponses = LinkCommonErrorResponses & {
    /**
     * @description Dry run started successfully
     */
    '200': {};
};
export type StartDryMappingIntegrationResponseSuccess = undefined;
export type StartDryMappingIntegrationSearchParams = undefined;
export type StartDryMappingIntegrationPathParameters = {
    integration_type: SchemaIntegrationType;
};
export const StartDryMappingIntegrationUrl = '/integrations/dry_mapping/{integration_type}/start' as const;
export const StartDryMappingIntegrationMethod = 'POST' as const;
export const getStartDryMappingIntegrationUrl = (params: StartDryMappingIntegrationPathParameters) =>
    StartDryMappingIntegrationUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof StartDryMappingIntegrationPathParameters) => String(params[param])
    );
